<template>
    <!-- Título sección -->
    <div class="flex justify-between">
      <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">&lt;ListaSolicitudes&gt;</span>
   
    </div>
 
      <div v-if="showModalBorrar" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
        <div class="bg-white rounded-xl shadow-lg w-80 p-5">
            
            <h2 class="text-lg font-semibold text-gray-800 mb-3">
            Confirmar acción
            </h2>

            <p class="text-sm text-gray-600 mb-4">
            ¿Está seguro que desea borrar? ({{ this.id }})
            </p>

            <p v-if="errorBorrar" class="text-red-500 text-xs mb-3">
            {{ errorBorrar }}
            </p>

            <div class="flex justify-end gap-2">
            <button 
                @click="cerrarModal"
                class="px-3 py-1 text-xs bg-gray-200 rounded-lg hover:bg-gray-300">
                Cancelar
            </button>

            <button 
                @click="confirmarBorrar"
                class="px-3 py-1 text-xs bg-red-500 text-white rounded-lg hover:bg-red-600">
                Borrar
            </button>
            </div>

        </div>
        </div>

    <div class="overflow-x-auto flex justify-center items-center "> 
    <!-- 
    /**
     * [ { "id": 2, "descripcion": "auto traslado al trabajo", "total": "0.00", "timestamp": "2026-04-29T12:50:44.263883-04:00", "presupuesto": 64250, "user": 1 } 
    */  
    -->
   <div  v-if="loading"  class=" rounded  cursor-pointer w-6 h-6 mx-auto border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>
   <table v-if="solicitudes.length>0" class="w-full text-sm text-gray-700">
  <!-- THEAD -->
  <thead class="bg-gray-100 text-gray-600 uppercase text-xs tracking-wide font-mono">
    <tr>
      <th class="text-left px-4 py-3 w-12">#</th>
      <th class="text-left px-4 py-3">Descripción item</th>
      <th class="text-right px-4 py-3 w-40">Total</th>
      <th class="text-right px-4 py-3 w-40">Acciones</th>
    </tr>
  </thead>

  <!-- TBODY -->
  <tbody>
    <tr
      v-for="(item, index) in solicitudes"
      :key="index"
      class="border-b hover:bg-gray-50 transition font-mono"
      :class="{ 'bg-gray-50': index % 2 !== 0 }">
      <!-- index -->
      <td class="px-4 py-3 text-gray-600">
        {{ index + 1 }}
      </td>

      <!-- descripcion -->
      <td class="px-4 py-3 font-medium text-gray-800 text-left ">
        {{ item.descripcion }}
      </td>

      <!-- total -->
      <td class="px-4 py-3 text-right">
        $ {{ $formatoMiles(item.total) }}
      </td>

      <!-- acciones -->
      <td class="px-4 py-3">
        
        <div class="flex justify-end gap-2">

          <button @click="set_idSolicitudEdit(item.id)" class="h-7 px-3 bg-blue-500 text-white text-xs rounded-xl shadow hover:bg-blue-600 transition">
            Editar
          </button>
          <button @click="modalAlertBorrar(item.id)" class="h-7 px-3 bg-red-500 text-white text-xs rounded-xl shadow hover:bg-red-600 transition" >
            Borrar
          </button>

        </div>

      </td>
    </tr>
  </tbody>

  <!-- TFOOT -->
  <tfoot class="bg-gray-100">
    <tr>
      <td colspan="2" class="px-4 py-3 text-right font-semibold">
        Total:
      </td>
      <td class="px-4 py-3 text-right font-semibold font-mono">
       {{ $formatoMiles(totalSolicitudes) }}
      </td>
      <td></td>
    </tr>
  </tfoot>
</table>
  </div>
      
</template>
<script>
import api from "@/api/axios";
 
export default {
  emits: ["recarga_solicitudes","set_idSolicitudEdit"],
  props: {
    propSolicitudes:{
        type: Array,
    }
  },
  data(){
    return{
       solicitudes: [],
       showModalBorrar:false,
       errorBorrar: null,
       loading: true,
       id:0
    }   
  },
  methods: {
    modalAlertBorrar(id) {
      this.showModalBorrar = true
      this.errorBorrar = null
      this.id=id
    },

    cerrarModal() {
      this.showModalBorrar = false
    },
    set_idSolicitudEdit(id){
        this.$emit('set_idSolicitudEdit',id)
    },
    async confirmarBorrar() {
      try {
        const result = await this.borrar(this.id)

        if (result === true) {
            this.cerrarModal()
        } else {
            this.errorBorrar = 'No se pudo borrar el registro.'
        }

      } catch (e) {
        this.errorBorrar = 'Error inesperado al borrar.'
      }
    },
    async borrar() {
          try {
              const data = {
                  solicitud_id: this.id,
              }

              const url = "api/v1/solicitud/del/"

              const resp = await api.post(url, data, {
                  headers: {
                      "Content-Type": "application/json",
                  },
              })

              const status = resp.data.status

              if (status === 200) {
                  this.$emit("recarga_solicitudes")
                  return true
              }

              return false

          } catch (err) {
              console.log(err)
              return false
          }
      }
  },
  watch:{
  propSolicitudes: {
      handler(val) 
      {
        if (val) {
          this.solicitudes = this.propSolicitudes;
          this.loading= false;
        }
      },
      immediate: true
    },
  },
  mounted(){
    this.solicitudes = this.propSolicitudes
  },
  computed: {
  totalSolicitudes() {
    return this.solicitudes.reduce((acc, item) => {
      return acc + Number(item.total || 0)
    }, 0)
  }
}
  

}
</script>